import { render, staticRenderFns } from "./MemberSubmenu.vue?vue&type=template&id=4f6132ed&"
import script from "./MemberSubmenu.vue?vue&type=script&lang=js&"
export * from "./MemberSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./MemberSubmenu.vue?vue&type=style&index=0&id=4f6132ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports